// ----------------------------------------------------------------------

const shape = {
	borderRadius: 4,
	borderRadiusSm: 16,
	borderRadiusMd: 8,
};

export default shape;
